import React from "react";
import { useAuth } from "../Contexts/AuthenticateProvider";
import NoPermission from "../Components/NoPermission";

// Route-level capability guard. Hiding a sidebar link or a button stops the
// normal path to a page, but the URL is still typeable and links get shared -
// so the page itself has to check too. The backend enforces the same keys
// independently; this is about not rendering a page whose actions would fail.
//
// Three modes:
//   capability={ONE_KEY}    - needs that one key
//   anyOf={[KEY_A, KEY_B]}  - needs at least one of them
//   allOf={[KEY_A, KEY_B]}  - needs ALL of them
//
// allOf is the important one. Several pages are only usable with a SET of
// capabilities, not one: the device-registration page, for instance, saves with
// vehicle.car.device but also has to load the hub list (hub.view) to fill its
// mandatory hub/location field, and the model's service schedule
// (vehicle.model.view). Granting only the write key lands someone on a form they
// can never submit, which is worse than not offering it at all.
const RequirePermission = ({ capability, anyOf, allOf, children }) => {
    const { hasPermission } = useAuth();

    if (allOf?.length) {
        return allOf.every((key) => hasPermission(key)) ? children : <NoPermission />;
    }
    const keys = anyOf || (capability ? [capability] : []);
    const allowed = !keys.length || keys.some((key) => hasPermission(key));
    return allowed ? children : <NoPermission />;
};

export default RequirePermission;
